/**
 * For Promo Code signups we have users go to the route `/signup/:promoCode`.
 *
 * There are some cases where we have reserved routes that cannot be a promo
 * code. This list keeps track and ensure we never create a promo code that is
 * the same name as a reserved route.
 */
export const RESERVED_SIGNUP_ROUTES = ["sent"];
